module.exports = __webpack_public_path__ + "img/ILHAS-MARSHAL.b9fcc1e6.png";